import {
    Item,
    ItemApiResponse,
} from 'components/customer/Confirmation/Invoice/entity/Item';
import {
    PaymentBreakdown,
    PaymentBreakdownApiResponse,
} from 'components/customer/Confirmation/Invoice/entity/PaymentBreakdown';
import {
    Totals,
    TotalsApiResponse,
} from 'components/customer/Confirmation/Invoice/entity/Totals';
import {
    Manufacturer,
    User,
} from 'components/customer/Confirmation/Invoice/entity/User';
import {
    PaymentMethod,
    PaymentMethodApiResponse,
} from 'components/customer/Confirmation/Invoice/entity/PaymentMethod';
import {camelizeKeys} from 'humps';
import {DateTime, Format} from '@cabinetsbycomputer/datetime';

export interface InvoiceData {
    invoiceNumber: string;
    invoiceDate: string;
    paymentTerms: string;
    jobId: number;
}

export interface InvoiceDataApiResponse {
    job_id: number;
    invoice_number: string;
    invoice_date: string;
    payment_terms: string;
}

export interface InvoiceApiResponse {
    invoice: InvoiceDataApiResponse;
    supplier: Manufacturer;
    customer: User;
    line_items: ItemApiResponse[];
    totals: TotalsApiResponse;
    payment_breakdown: PaymentBreakdownApiResponse;
    payment_options: PaymentMethodApiResponse[];
}

export interface Invoice {
    invoice: InvoiceData;
    supplier: Manufacturer;
    customer: User;
    lineItems: Item[];
    totals: Totals;
    paymentBreakdown: PaymentBreakdown;
    paymentOptions: PaymentMethod[];
}

export const mapInvoice = (rawInvoice: InvoiceApiResponse) => {
    const invoice = camelizeKeys(rawInvoice) as Invoice;

    if (invoice?.invoice?.invoiceDate) {
        invoice.invoice.invoiceDate = DateTime.parseCustom(
            invoice.invoice.invoiceDate,
            Format.Date
        )
            .format(Format.DateBritishDashed)
            .toString();
    }

    return invoice;
};
